import React, { useEffect, useState, useRef } from 'react';
import { Col, Row, Card, Form, Button, Spinner, Tab, Nav, Container, InputGroup } from 'react-bootstrap';
import { useParams, useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast, isNative } from '../context/MenuProvider';
import SelecionarTipoDeContato from '../components/Utils/SelecionarTipoDeContato';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import ReceberValor from '../components/Venda/ReceberValor';
import PerfilParte from '../components/Utils/PerfilParte';
import { OpcoesPagamento, PagamentosAberto } from './LinkPagamento';
import Markdown from '../components/Utils/Markdown';
import { Geolocation } from '@capacitor/geolocation';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const baixarCliente = (cliente_id) => {
    const mensagem = {
      tipo: 'baixar-cliente',
      id: parseInt(cliente_id)
    };

    // ✅ FLUXO PWA
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(mensagem);
    } 
    // ✅ FLUXO NATIVO (APK)
    else {
        // No nativo, enviamos para a própria window pois o service-worker.js
        // foi carregado como um script comum que ouve a window.
        window.dispatchNativeMessage(mensagem);
    }
}


const ClienteDetails = () => {
  const { id, tipo } = useParams();
  const { 
    links, 
    setLinks, 
    setBtns,
    crud,
    buscarDadosPorId,
    excluirDadosPorId,
    salvarDados,
    setTitle,
    hasPerms,
  } = useProvider();
  const navigate = useNavigate();
  const { del, loading, get, post,  patch } = crud || {};
  const [cliente, setCliente] = useState(null);
  const [formType, setFormType] = useState(tipo || 'home');
  
  setTitle('Cliente');

  const excluirCliente = (id) => {
    Swal.fire({
      title: "Exluir cliente?",
      text: "Você não poderá reverter isso!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, excluir!"
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
          await del(`/gvendas/clientes/${id}/`);
          await excluirDadosPorId("db_clientes", id);
          Toast.fire({
              icon: "success",
              title: `Cliente excluído com sucesso`
          });
          navigate(-1);
        }catch(err){
          Swal.fire({
            title: `Erro ${err.status}`,
            text: 'Cliente não pode ser excluído',
            icon: "error"
          });
        }finally{
          
        }
      }
    });
  }
  
  useEffect(() => {
    const newLinks = [
      //{ name: 'Perfil do cliente', onClick:() => {setFormType('detalhes')}},
      { name: 'Nova Venda', to: `/vendas/carrinho/${id}` },
      { name: 'Novo Compromisso', to: `/vendas/carrinho/${id}` },
      //{ name: 'Novo Cliente', to: '/clientes/novo' },
      { divider: true},
      { name: 'Editar Cliente', to: `/clientes/${id}/editar/cliente/` },
      //{ divider: true},
      { divider: true, name: 'Acompanhamentos', onClick:() => {setFormType('agenda')}}
    ]
    if(cliente?.is_cliente){
      newLinks.push({ name: 'Compras', onClick:() => {setFormType('compras')}});
      newLinks.push({ name: 'Pagamentos', onClick:() => {setFormType('pagamentos')}});
    }
    if(cliente?.numero_de_compras===0){
      newLinks.push({ divider: true})
      newLinks.push({ name: 'Excluir Cliente', onClick:() => {excluirCliente(id)}});
    }
    setLinks(newLinks);
    setBtns([
      //{icon:'bi-trash', onClick:() => {alert('excluir')}},
      {icon:'bi-geo-alt', onClick:() => {buscarLocalizacaoGPS()}},
      {icon:'bi-pencil-square', to:`/clientes/${id}/editar/cliente/`},
    ]);
    return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns, formType, cliente]);

   const buscarLocalizacaoGPS = async () => {
    try {
      if (isNative) {
        // No Nativo, verificamos e solicitamos explicitamente para garantir
        let permStatus = await Geolocation.checkPermissions();
  
        if (permStatus.location !== 'granted') {
          permStatus = await Geolocation.requestPermissions();
        }
  
        if (permStatus.location === 'granted') {
          const coordinates = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            maximumAge: 0 // Garante que buscará uma nova posição e não usará cache
          });
          const { latitude, longitude } = coordinates.coords;
          await atualizarLocalizacao(latitude, longitude);
        }
      } else if (navigator.geolocation) {
        // No Navegador, o próprio navegador gerencia o prompt ao executar esta linha
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            await atualizarLocalizacao(latitude, longitude);
          },
          (error) => {
            console.error(error);
          },
          {
            enableHighAccuracy: true,
            maximumAge: 0 // Garante que buscará uma nova posição no navegador
          }
        );
      }
    } catch (err) {
      console.error('Erro ao buscar endereço:', err);
    }
  };

  
  const atualizarLocalizacao = async(latitude, longitude)=>{
    Swal.fire({
      title: "Alterar Localizaçã",
      text: "Tem certeza que deseja alterar a localização do cliente?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, alterar!"
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
              const localizacao = `${latitude},${longitude}`;
              //alert(localizacao)
              const response = await patch({
                "posicao_mapa":localizacao,
              },`/gvendas/clientes/${id}/?filtros=posicao_mapa,foto_mapa`);
              if(response && response.length){
                setCliente((prevItem)=>({
                  ...prevItem,
                  posicao_mapa:response[0].posicao_mapa,
                  foto_mapa:response[0].foto_mapa,
                }));
                Toast.fire({
                      icon: "success",
                      title: `Localização atualizada com sucesso`
                });
              }
        }catch(err){
          Swal.fire({
            title: `Erro ${err.status}`,
            text: 'Falha ao alterar a localização',
            icon: "error"
          });
        }finally{
          
        }
      }
    });
  }
  
  const isConsultaCarregada = useRef(false);
  const buscarClienteLocal = async() => {
      try{
          const clienteLocal = await buscarDadosPorId("db_clientes", parseInt(id));
          if(clienteLocal){
            if (isConsultaCarregada.current) return;
            setCliente((item) => ({
              ...item,
              ...clienteLocal
            }));
          }
      }catch(err){
      
      }
  }
  const buscarCliente = async() => {
      try{
          const response = await get(
            `/gvendas/clientes/${id}/`,
            'pagina'
          );
          if(response && response.length){
            isConsultaCarregada.current = true;
            setCliente(response[0]);
          }
      }catch(err){
        //alert(JSON.stringify(err.response?.data || err.response))
      }finally{
          
      }
  }
    


  useEffect(() => {
      if(id){
        buscarClienteLocal();
        buscarCliente();
      }
  }, [id, tipo]);
  
  return (
    <>
      <PerfilParte  cliente={cliente} />
      <MenuTab cliente = {cliente} onFunction={buscarCliente} setCliente={setCliente} formType={formType} setFormType={setFormType} />
    </>
  );
};

const MenuTab = ({ cliente, setCliente, formType, setFormType, onFunction}) => {
  
  return (
    <>
      {/* Nav Tabs */}
      <Tab.Container id="details-tabs" activeKey={formType} onSelect={(k) => setFormType(k)}>
        <Nav variant="tabs" className="justify-content-center fs-4">
          {cliente && (
            <>
              <Nav.Item>
                <Nav.Link eventKey="home"><i class='bx bx-home-alt-2'></i></Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="like"><i class='bx bx-like'></i></Nav.Link>
              </Nav.Item>
          </>)}
          {cliente && cliente?.telefone && (
            <Nav.Item>
              <Nav.Link eventKey="contato"><i class='bx bxl-whatsapp'></i></Nav.Link>
            </Nav.Item>
          )}
          {cliente && cliente?.is_cliente && (
            <Nav.Item>
              <Nav.Link eventKey="compras"><i class='bx bx-shopping-bag'></i></Nav.Link>
            </Nav.Item>
          )}
          {cliente && cliente?.is_cliente && (
            <Nav.Item>
              {formType === "pagamentos-editar" ? (
                <Nav.Link eventKey="pagamentos-editar"><i class='bx bx-dollar'></i></Nav.Link>
              ):(
                <Nav.Link eventKey="pagamentos"><i class='bx bx-dollar'></i></Nav.Link>
              )}
            </Nav.Item>
          )}
          {cliente && (
            <Nav.Item>
              <Nav.Link eventKey="agenda"><i class='bx bx-calendar'></i></Nav.Link>
            </Nav.Item>
          )}
        </Nav>

        <Tab.Content className="">
          {/* Painel de Login */}
          {formType === 'home' && cliente && <Home setFormType={setFormType} onFunction={onFunction} cliente={cliente}  setCliente={setCliente}  />}
          {formType === 'like' && cliente && <Indicacoes cliente={cliente} setCliente={setCliente}   />}
          {formType === 'contato' && cliente && cliente?.telefone && <Contato cliente={cliente}  />}
          {formType === 'compras' && cliente && cliente?.is_cliente && <Compras cliente={cliente}  />}
          {formType === 'pagamentos' && cliente && cliente?.is_cliente && <Pagamentos cliente={cliente} setFormType={setFormType} />}
          {formType === 'pagamentos-editar' && cliente && cliente?.is_cliente && <Pagamentos cliente={cliente} editar={true} setFormType={setFormType} />}
          {formType === 'agenda' && cliente && <Agenda cliente={cliente}  />}
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

const Home = ({ setFormType, onFunction, cliente, setCliente }) => {
  const [result, setResult] = useState();
  const [valor, setValor] = useState();
  const {
    crud,
    hasPerms,
  } = useProvider();
  const { post } = crud || {};
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!result) return;
  
    setCliente(prev => ({
      ...prev,
      total_aberto: result.total_aberto,
      data_ultimo_pagamento: result.data_ultimo_pagamento,
      total_em_pagamentos: result.total_em_pagamentos,
      ticket_medio: result.ticket_medio,
      ticket_medio_de_parcelas: result.ticket_medio_de_parcelas,
    }));
  }, [result]);
  
  const formatTelefone = (telefone) => {
    telefone = telefone.replace(/\D/g, '');
    if (!telefone) return '';
    return `+55${telefone}`;
  }
  
  useEffect(()=>{
    if(!cliente?.id) return;
    baixarCliente(parseInt(cliente?.id));
  }, [cliente?.id])
  
  
  const whatsapp = ({telefone, link, valor})=>{
        const mensagem = encodeURIComponent(`Oi, aqui está o link de pagamento no valor de ${parseFloat(valor||0).toLocaleString(
            'pt-br',
            {
              style: 'currency',
              currency: 'BRL',
            }
          )}\n\n${link}`);
        const url = `whatsapp://send?${formatTelefone(telefone) ? `phone=${formatTelefone(telefone)}&` : ""}text=${mensagem}`;
        window.open(url, '_blank', 'noopener,noreferrer');
  }
  

  return (
    <>
      <Row>
        <Col className="mt-3">
          {cliente?.telefone && <div>Telefone: {cliente?.telefone}</div>}
          {cliente?.endereco && <div>Endereço: {cliente?.endereco}</div>}
          {cliente?.dia_do_aniversario && (
            <div>
              Aniversário:{' '}
              {dayjs(cliente?.dia_do_aniversario)
                .year(dayjs().year())
                .format('DD/MM dddd')}
            </div>
          )}
          {cliente?.observacoes && (
            <div>
              Obs:<br />
              <Markdown texto={cliente?.observacoes}></Markdown>
            </div>
          )}
        </Col>
      </Row>

      {cliente?.tempo_ultimo_contato && (
        <Card.Text>Último contato {cliente?.tempo_ultimo_contato}</Card.Text>
      )}

      {parseFloat(cliente?.numero_de_compras||0) >0 && (
        <Card.Text>
          {cliente?.numero_de_compras || 0} compra
          {cliente?.numero_de_compras > 1 ? 's' : ''}, última {' '}
          {cliente?.tempo_ultima_compra || 'dias'}
          <br />
          Pago:{' '}
          {parseFloat(cliente?.total_em_pagamentos || 0).toLocaleString(
            'pt-br',
            {
              style: 'currency',
              currency: 'BRL',
            }
          )}{' '}
          em aberto:{' '}
          {parseFloat(cliente?.total_aberto || 0).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
          <div>
            Ticket Médio:{' '}
            {parseFloat(cliente?.ticket_medio || 0).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
          <div>
            Última Compra:{' '}
            {cliente?.data_ultima_compra && (<>
              {dayjs(cliente.data_ultima_compra).format("DD/MM/YYYY dddd")}
            </>)}
          </div>
          <div>
            Último Pagamento:{' '}
            {cliente?.data_ultimo_pagamento && (<>
              {dayjs(cliente.data_ultimo_pagamento).format("DD/MM/YYYY dddd")}
            </>)}
          </div>
          {(hasPerms("loja.view_venda")  && parseFloat(cliente?.total_aberto || 0)>0) && (<>
            <div className="text-center py-4">
                <OpcoesPagamento 
                  perm_online={hasPerms("pagamento_online.view_configurarpagamento")}
                  clienteId={parseInt(cliente?.id || 0)} 
                  totalAberto={parseFloat(cliente?.total_aberto || 0)} 
                  pagar={parseFloat(valor || cliente?.total_aberto || 0)} 
                  conInstrucoes={false} 
                  setResult={setResult}
                  hash_token={cliente?.hash_token}
                  redirecionar={`/clientes/${parseInt(cliente?.id || cliente)}/pagamentos/`}
                />
            </div>
            <div className="text-center">
              <Button variant="outline-dark" size="sm" onClick={()=>setFormType("pagamentos-editar")}>Alterar datas de vencimentos</Button>
            </div>
            {/*
            */}
            <PagamentosAberto clienteId={cliente.id} hash_token={cliente?.hash_token} valorAberto={parseFloat(cliente?.total_aberto || 0)} setValor={setValor} layout={"admin"} />
          </>)}
        </Card.Text>
      )}
      <Row>
        <Col className="mt-2">
          {cliente?.indicacoes > 0 && (
            <div>Indicações: {cliente?.indicacoes?.length || 0}</div>
          )}
          {cliente?.score > 0 && (
            <div>Nota: {cliente?.score || 0}/1000</div>
          )}
        </Col>
      </Row>
    </>
  );
};
const Indicacoes = ({ cliente, setCliente }) => {
  const {
    crud,
  } = useProvider();
  const { get, patch, loading } = crud || {};
  const [indicacoes, setIndicacoes] = useState([]);
  const [addIndicacoes, setAddIndicacoes] = useState(false);
  
  useEffect(()=>{
    const buscarLista = async()=>{
      try{
        const response = await get(`/gvendas/clientes/${cliente?.id}/?expand=regiao,indicacoes&filtros=id,nome_do_cliente,telefone,nome,indicacoes`);
        //alert(JSON.stringify(response))
        if(response && response.length){
          setIndicacoes(response[0].indicacoes);
          setCliente((prevItem)=>({
            ...prevItem,
            indicacoes:response[0].indicacoes
          }));
        }
      }catch(err){
        
      }
    }
    if(cliente && !addIndicacoes) buscarLista();
  },[addIndicacoes])
  

  const remover = (item) => {
    Swal.fire({
      title: "Remover indicação?",
      text: "Remover contato da lista de indicações",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, remover!"
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
          const lista = {
            indicacoes: indicacoes
              .filter(i => i.id !== item.id)
              .map(i => i.id)
          }
          // alert(item.id)
          // alert(JSON.stringify(lista))
          const response = await patch(lista, `/gvendas/clientes/${cliente?.id}/?expand=regiao,indicacoes&filtros=id,nome_do_cliente,telefone,nome,indicacoes`);
          if(response && response.length){
            //setIndicacoes(indicacoes.filter(i => i.id !== item.id));
            setIndicacoes(response[0].indicacoes);
            setCliente((prevItem)=>({
              ...prevItem,
              indicacoes:response[0].indicacoes
            }));
            Toast.fire({
                icon: "success",
                title: `Indicação removida com sucesso`
            });
          }
        }catch(err){
          Swal.fire({
            title: `Erro ${err.status}`,
            text: 'Indicação não pode ser removida',
            icon: "error"
          });
        }finally{
          
        }
      }
    });
  }
  
  const formatTelefone = (telefone) => {
    telefone = telefone.replace(/\D/g, '');
    if (!telefone) return '';
    return `+55${telefone}`;
  }
  
  const whatsapp = (telefone)=>{
        const mensagem = encodeURIComponent("Oi");
        const url = `whatsapp://send?${formatTelefone(telefone) ? `phone=${formatTelefone(telefone)}&` : ""}text=${mensagem}`;
        window.open(url, '_blank', 'noopener,noreferrer');
  }
  
  return (<>

    <div className="border-dashed-bottom mb-2 mt-3">
      Indicações
    </div>
    {!addIndicacoes && (<>
      <BotaoFlutuante onClick={()=>setAddIndicacoes(true)} icon="bi-plus"></BotaoFlutuante>
      <div className="list-group mt-3 mb-5">
          {indicacoes.length > 0 ? (
            indicacoes.map((x) => (
              <RenderizarProduto
                key={x.id} // Adicionando key para cada componente da lista
                //to={`/agenda?p=detalhes&i=${x.id}`}
                col="d-none"
                lm="mb-1"
                text1={x.telefone}
                titulo={x.nome_do_cliente}
                extra={(<>
                  <div className="border-top pt-2">
                    <Row>
                      <Col>{x.regiao?.nome}</Col>
                      <Col xs="auto">
                        {x.telefone && <Button variant="outline-success" className="btn btn-sm me-2" onClick={()=>whatsapp(x.telefone)}><i className="bx bxl-whatsapp"></i></Button>}
                        <Button variant="outline-danger" onClick={()=>remover(x)} className="btn btn-sm">Remover</Button>
                      </Col>
                    </Row>
                  </div>
                </>)}
              />
            ))
          ) : (
            !loading && <p className="text-center text-muted">Nenhuma indicação encontrada.</p>
          )}
          {loading && <p className="text-center"><Spinner animation="border" /></p>}
        </div>
    </>)}
    {addIndicacoes && (<>
      <ContatosDeIndicacoes setAddIndicacoes={setAddIndicacoes} cliente={cliente}   />
    </>)}
  </>)
}
const ContatosDeIndicacoes = ({ cliente, setAddIndicacoes }) => {
  const {
    crud,
  } = useProvider();
  const { get, patch, loading } = crud || {};
  const [query, setQuery] = useState('');
  const [nextUrl, setNextUrl] = useState(null);
  const [clientes, setClientes] = useState([]);

    // Função para buscar clientes na API
    const buscarClientes = async (novaBusca = false) => {
        let url = `/gvendas/clientes/?expand=regiao&filtros=id,telefone,endereco,ativo,foto_perfil,foto_mapa,nome,nome_do_cliente`;

        if (query) url += `&search=${query}`;

        if (novaBusca) {
            setClientes([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        
        try {
            const response = await get(url, 'pagina');
            //alert(JSON.stringify(response));
            if (response) {
                const novosItens = response[0].results;
                //setDado('lista_clientes', [...clientes,...novosItens]); 
                setClientes((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
                setNextUrl(response[0].next);
            }
        } catch (err) {
          
            // alert(JSON.stringify(err.response))
            // Toast.fire({
            //     icon: "error",
            //     title: "Falha ao buscar clientes"
            // });
        } finally {
            
        }
    };
    
  const addNaLista = async(item)=>{
    try{
      const lista = {
        indicacoes: [...(cliente?.indicacoes.map(i => i.id) || []), item.id]
      };
      const response = await patch(lista, `/gvendas/clientes/${cliente?.id}/`);
      if(response && response.length){
        setAddIndicacoes(false);
      }
    }catch(err){
      
    }
  }
  useEffect(()=>{
    if(query) buscarClientes(true);
  }, [query])
  
    // Detecta o fim da página para carregar mais clientes
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarClientes();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
  
  return (<>
    <div className="input-group">
              <Form.Control 
                type="text" 
                placeholder="Pesquisar..." 
                value={query} 
                onChange={(e) => setQuery(e.target.value)} 
              />
              <Button variant="secondary" onClick={() => buscarClientes(true)}>
                <i className="bi bi-search"></i>
              </Button>
            </div>
    
    <div className="list-group mt-3">
        {clientes.length > 0 ? (
          clientes.map((x) => (
            <RenderizarProduto
              key={x.id} // Adicionando key para cada componente da lista
              //to={`/agenda?p=detalhes&i=${x.id}`}
              col="d-none"
              lm="mb-1"
              text1={x.telefone}
              titulo={x.nome_do_cliente}
              extra={(<>
                <div className="border-top pt-2 text-muted small">
                  <Row>
                    <Col>{x.regiao?.nome}</Col>
                    <Col xs="auto">
                      <Button variant="outline-success" onClick={()=>addNaLista(x)} className="btn btn-sm">Adicionar</Button>
                    </Col>
                  </Row>
                </div>
              </>)}
            />
          ))
        ) : (
          (!loading && query) && <p className="text-center text-muted">Nenhum contato encontrado.</p>
        )}
        {loading && <p className="text-center"><Spinner animation="border" /></p>}
      </div>
  </>)
}
const Contato = ({ cliente }) => {
  const navigate=useNavigate();
  const [filtroTipoContato, setFiltroTipoContato] = useState('')
  const [mensagem, setMensagem] = useState('');
  const [dataProgramada, setDataProgramada] = useState();
  const {
    crud,
    auth,
    hasPerms
  } = useProvider();
  const { del, loading, get, post } = crud ||{};
  
  useEffect(() => {
      if(cliente && filtroTipoContato){
        gerarMensagem();
      }
  }, [cliente, filtroTipoContato]);
  
  const gerarMensagem = async () => {
    if (!cliente?.telefone){
      Toast.fire({
          icon: "error",
          title: `Cliente sem WhstaApp cadastrado`
      });
      return
    }
    const instrucoes = `
      Nome do cliente: ${cliente?.nome_do_cliente?.trim().split(' ')[0]}
      Valor total pago: ${cliente?.total_em_pagamentos},
      Valor total em aberto: ${cliente?.total_aberto},
      sendo ${cliente?.venda_total_atrasado} em atraso,
      total de compras: ${cliente?.numero_de_compras},
      última compra: ${cliente?.tempo_ultima_compra},
      última visita ao cliente: ${cliente?.tempo_ultimo_contato},
    `;
    try{
      const data = {
          "instrucoes": `${instrucoes}. sempre em primeira pessoa, resposta curta e direta para WhatsApp`,
          "contexto": filtroTipoContato
      }
      const response = await post(data, `/assistente-ia/openai-chat/gerar-mensagem/`);
      if(response){
        setMensagem(response[0].response)
      }
    }catch(err){
      Toast.fire({
          icon: "error",
          title: `${err}`
      });
    }finally{
      
    }
  }
  
  const handleSubmit = async (e) => {
    if(e) e.preventDefault();
    if (dataProgramada){
      const agendarMensagem ={
        data_programada:dataProgramada||null,
        mensagem:mensagem,
        clientes:[cliente.id]
      }
      if (!cliente?.telefone){
        Toast.fire({
            icon: "error",
            title: `Cliente sem WhstaApp cadastrado`
        });
        return
      }
      try{
        //alert(JSON.stringify(agendarMensagem))
        const response = await post(agendarMensagem, `/core/mensagens-whatsapp/criar-mensagens/`);
        //alert(JSON.stringify(response))
        if(response && response.length){
          Toast.fire({
            icon: 'success',
            title: 'Mensagem Agendada'
          });
          navigate("/mensagens/");
        }
      } catch(err){
          if (Array.isArray(err.response.data)) {
            console.log("É um array");
            Toast.fire({
              icon: 'error',
              title: JSON.stringify(err.response.data) || 'Não foi possível agendar'
            });
          } else if (typeof err.response.data === "object") {
            console.log("É um objeto");
            Toast.fire({
              icon: 'error',
              title: err.response.data?.data_programada || 'Não foi possível agendar'
            });
          } else if (typeof err.response.data === "string") {
            Toast.fire({
              icon: 'error',
              title: err.response.data || 'Não foi possível agendar'
            });
            console.log("É uma string");
          }
        //alert(JSON.stringify(err.response))
      }
    } else {
      const mensagemEnc = encodeURIComponent(mensagem);
      const telefone = `55${cliente?.telefone.replace(/\D/g, '')}`;
      const url = `whatsapp://send?${telefone ? `phone=${telefone}&` : ""}text=${mensagemEnc}`;
      //addRelacionamento(cliente, mensagem)
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
  
  return (<>
    <Form onSubmit={handleSubmit}>
      {/*
      <SelecionarTipoDeContato  tipoDeContatoId={filtroTipoContato} setTipoDeContatoId={setFiltroTipoContato} defaultText="Selecione um tipo de mensagem" adicionalText="Padrão" adicionalValue="Escreva uma mensagem que eu lembrei do cliente e resolvi escrever uma mensagem para saber como está" label="Tipo de mensagem"/>
      */}
      <Form.Group controlId="formAgendar" className="mt-3">
        <InputGroup>
          <span className="input-group-text">{cliente?.telefone}</span>
          {auth?.empresa?.whatsapp_conectado && (<>
            <span className="input-group-text"><i className="bx bx-timer"></i></span>
            <Form.Control 
                type="datetime-local" 
                value={dataProgramada} 
                onChange={(e) => setDataProgramada(e.target.value)} 
            />
          </>)}
        </InputGroup>
      </Form.Group>
      <Form.Group controlId="formMensagem" className="mt-3">
        <Form.Label>Mensagem</Form.Label>
        <Form.Control 
            as="textarea" 
            value={mensagem} 
            onChange={(e) => setMensagem(e.target.value)} 
            rows={5} 
        />
      </Form.Group>
      <Button variant="secondary" type="submit" className="mt-4 w-100" disabled={loading || !mensagem || !cliente?.telefone}>
        Enviar Mensagem
      </Button>
    </Form>
    
    {hasPerms("core.view_whatsappmensagem") && <MensagensWhatsApp cliente={cliente} />}
  </>)
}
const Compras = ({ cliente}) => {
  const navigate = useNavigate();
  const [vendas, setVendas] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const {
    crud,
    salvarDados,
  } = useProvider();
  const { del, loading, get, post } = crud ||{};

  const buscarVendas = async (novaBusca = false) => {
    //let url = `/gvendas/vendas/?cliente_ids=${cliente?.id}&ordering=-data_da_venda&filtros=id,total,total_pago,total_aberto,data_da_venda`;
    let url = `/gvendas/vendas/?cliente=${cliente?.id}&ordering=-data_da_venda&expand=venda_itensvenda,produto`;

    if (novaBusca) {
      setVendas([]);
      setNextUrl(null);
    } else if (nextUrl) {
      url = nextUrl;
    } else {
      url = null;
    }

    if (loading || !url) return;
    try {
      const response = await get(url, 'pagina');
      if (response) {
        const novosVendas = response[0].results;
        setVendas((vendasAnteriores) => novaBusca ? novosVendas : [...vendasAnteriores, ...novosVendas]);
        setNextUrl(response[0].next);
      }
    } catch (err) {
      // Toast.fire({
      //   icon: "error",
      //   title: "Falha ao buscar compras"
      // });
    } finally {
      // Nada a ser feito aqui
    }
  };
  


  // Inicialização  
  useEffect(() => {
    if (cliente) {
      buscarVendas(true);
    }
  }, [cliente]);

  // Detecta o fim da página para carregar mais vendas
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading) buscarVendas();
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [nextUrl, loading]);

  const getImgStatus = (x) => {
    if(x.total_aberto <= 0){
      return '/images/img_pago.jpg';
    }else if(x.total_aberto > 0 && x.total_pago > 0){
      return '/images/img_parcial.jpg';
    }else{
      return '/images/img_fiado.jpg';
    }
  }
  
  const getUrlDestino = async (e) => {
        if (!e.ativo){
          Swal.fire({
            title: "Cliente inativo, reative para continuar...",
            icon: "warning",
            draggable: true
          });
          return
        }
        await salvarDados('local_registros', { 
          venda: {
            cliente: e,
          },
          id:'checkout',
        });
        navigate(`/checkout/adicionar-produtos`, { replace: true });
  };

  const vendasAgrupadas = vendas.reduce((acc, venda) => {
    const data = dayjs(venda.data_da_venda).format("DD/MM/YYYY dddd"); // Assumindo que data_da_venda está no formato desejado
    if (!acc[data]) {
      acc[data] = [];
    }
    acc[data].push(venda);
    return acc;
  }, {});

  return (
    <>
      <BotaoFlutuante onClick={()=>getUrlDestino(cliente)} icon="bi-plus"></BotaoFlutuante>

      <div className="list-group mt-3">
        {Object.entries(vendasAgrupadas).length > 0 ? (
          Object.entries(vendasAgrupadas).map(([data, vendasDoDia]) => (
            <div key={data}>
              <div className="text-muted mt-2">{data}</div>
              {vendasDoDia.map((x) => (
                <RenderizarProduto
                  key={x.id} // Adição de key para a lista
                  to={`/vendas/${x.id}`}
                  lm="mb-1"
                  src={getImgStatus(x)}
                  className="rounded-circle img-fluid"
                  col2="col-auto text-end"
                  titulo={(
                        <>
                          {parseFloat(x.desconto || 0)>0 && (
                            <>
                              <s className="small fs-6 text-muted">
                                {parseFloat(x.sub_total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                              </s>
                              {` `}
                            </>
                          )}
                          {parseFloat(x.total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                        </>
                  )}
                  text2={`Pago: ${parseFloat(x.total_pago||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} em aberto ${parseFloat(x.total_aberto||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`}
                  extra={(<>
                    {x.venda_itensvenda.map((x) =>(<>
                      <div className="border-top py-1 mt-1">
                        {x.quantidade}x {x.produto.nome_do_produto}
                      </div>
                    </>))}
                  </>)}
                />
              ))}
            </div>
          ))
        ) : (
          !loading && <p className="text-center text-muted">Nenhuma venda encontrada.</p>
        )}
        {loading && <p className="text-center"><Spinner animation="border" /></p>}
        {(!loading && nextUrl) && (
          <Button variant="secondary" onClick={() => buscarVendas(false)} className="mt-2">
            Buscar mais...
          </Button>
        )}
      </div>
    </>
  );
};
const Pagamentos = ({ cliente, editar, setFormType}) => {
  const [isEditar, setIsEditar] = useState(editar);
  const [pagamentos, setPagamentos] = useState([]);
  const [acordo, setAcordo] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const {
    crud,
  } = useProvider();
  const { del, loading, get, post } = crud||{};
  
  const buscarPagamentos = async (novaBusca = false) => {
    let url = `/gvendas/pagamentos/?venda__cliente__in=${cliente?.id}&ordering=-data_do_pagamento&filtros=id,pago,referencia,valor_total,forma_de_pagamento,data_do_pagamento,venda`;
    
    if (novaBusca) {
      setPagamentos([]);
      setNextUrl(null);
    } else if (nextUrl) {
      url = nextUrl;
    } else {
      url = null;
    }

    if (loading || !url) return;
    try {
      const response = await get(url,'pagina');
      if (response) {
        const novosPagamentos = response[0].results;
        setPagamentos((pagamentosAnteriores) => novaBusca ? novosPagamentos : [...pagamentosAnteriores, ...novosPagamentos]);
        setNextUrl(response[0].next);
      }
      
    } catch (err) {

    } finally {
      // Nada a ser feito aqui
    }
  };
  
  // Inicialização  
  useEffect(() => {
    if (cliente) {
      buscarPagamentos(true);
    }
  }, [cliente, isEditar]);
  
  // Detecta o fim da página para carregar mais pagamentos
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading) buscarPagamentos();
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [nextUrl, loading]);
  
  
    
  const pagamentosAgrupados = pagamentos.reduce((acc, pagamento) => {
    const data = pagamento.data_do_pagamento;
  
    if (!acc[data]) {
      acc[data] = {
        itens: [],
        total: 0,
        pago: 0,
      };
    }
  
    acc[data].itens.push(pagamento);
    acc[data].total += parseFloat(pagamento.valor_total || 0);
    acc[data].pago += pagamento.pago ? parseFloat(pagamento.valor_total || 0) : 0;
  
    return acc;
  }, {});
  
  const listaAcordo = Object.entries(pagamentosAgrupados)
  .sort(([dataA], [dataB]) => dayjs(dataA).unix() - dayjs(dataB).unix())
  .map(([data, grupo]) => ({
    data: dayjs(data).format("YYYY-MM-DD"),
    valor: parseFloat(grupo.total - grupo.pago).toFixed(2),
  }));
  
  useEffect(()=>{
    setAcordo(listaAcordo);
  },[pagamentos])
  
  const getColor = (data, pago, obj) => {
      const dataPagamento = dayjs(data).startOf('day');
      const hoje = dayjs().startOf('day');
  
      if (pago) return 'green';
      if (dataPagamento.isSame(hoje)) return 'orange';
      if (dataPagamento.isBefore(hoje)) return 'red';
      if (dataPagamento.isBefore(hoje)) return 'red';
      //if (!obj?.venda?.cliente?.ativo && !obj.financeiro) return 'black';
      return 'inherit';
  };

  
  return (
    <>
      <div className="list-group mt-3">
        <div className="text-center">
          <Button size="sm" variant="outline-dark" className="px-5" onClick={()=>setIsEditar(!isEditar)}>{isEditar ?"Visulizar pagamentos":"Reagendar pagamentos"}</Button>
        </div>
        {isEditar && (<>
          <PagamentoEditar cliente={cliente} lista={acordo} setLista={setAcordo} setIsEditar={setIsEditar} setFormType={setFormType}/>
        </>)}
        {!isEditar && (<>
          {Object.entries(pagamentosAgrupados).length > 0 ? (
            Object.entries(pagamentosAgrupados).map(([data, pagamentosDoDia]) => (
              <div key={data}>
                <Row className="text-muted mt-2">
                  <Col>{dayjs(data).format("DD/MM/YYYY dddd")}</Col>
                  <Col xs="auto">{parseFloat(pagamentosDoDia.total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
                  
                </Row>
                {pagamentosDoDia.itens.map((x) => (
                  <RenderizarProduto
                    key={x.id} // Adição de key para a lista
                    to={`/vendas/${x.venda?.id||x.venda}/${x.id}`}
                    lm="mb-1"
                    bcolor={getColor(x.data_do_pagamento, x.pago, x)}
                    col="d-none"
                    col2="col-auto text-end"
                    text1={x.referencia}
                    titulo3={parseFloat(x.valor_total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    text2={x.forma_de_pagamento}
                    text3={x.pago ? 'recebido' : 'receber'}
                  />
                ))}
              </div>
            ))
          ) : (
            !loading && <p className="text-center text-muted">Nenhum pagamento encontrado.</p>
          )}
          {loading && <p className="text-center"><Spinner animation="border" /></p>}
          {(!loading && nextUrl) && (
            <Button variant="secondary" onClick={() => buscarPagamentos(false)} className="mt-2">
              Buscar mais...
            </Button>
          )}
        </>)}
      </div>
    </>
  );
};
const PagamentoEditar = ({ cliente, lista, setLista, setIsEditar, setFormType}) => {
  const {
    crud,
    auth,
    salvarDados,
  } = useProvider();
  
  const navigate = useNavigate();
  const { get, post, patch, del, loading } = crud;
  const [naUltima, setNaUltima] = useState(true);
  
  const pagamentoToItem = (item) => {
      return { 
          valor:parseFloat(item.valor||0), 
          data:item.data || null,
      };
  }
  
  const salvarPagamentos = async(redirecionar = true) => {
    let pgmts = [];
    lista.forEach((item) => {
        pgmts.push(pagamentoToItem(item));
    });
    const formData = {
        "itens":pgmts,
    }
    
    try{
      //alert(JSON.stringify(formData))
      const response = await post(formData,`/gvendas/clientes/${parseInt(cliente?.id || cliente)}/reprogramar-pagamentos/`);
      if (response && response.length){
        //alert(JSON.stringify(response[0]))
        baixarCliente(parseInt(cliente?.id || cliente));
        Toast.fire({
          icon: 'success',
          title: 'Reagendamento concluído!'
        });
        setIsEditar(false);
        //alert(setFormType)
        setFormType("home");
      }
      
    }catch(err){
      //alert(JSON.stringify(err.response.data))
      if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
        const id_cliente = parseInt(cliente?.id || cliente);
        await salvarDados('db_sync', {
          //id:`recebimento_${cliLocal?.nome_do_cliente || id_cliente}`,
          returnUrl:`/clientes/${cliente?.id}`,
          metodo: "PATCH",
          titulo: `Reagendamento de pagamentos`,
          info: `${cliente?.nome || `Cliente Id: ${parseInt(cliente?.id || cliente)}`}`,
          descricao: `
            <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr><th>${cliente?.nome || `Cliente Id: ${parseInt(cliente?.id || cliente)}`}</th></tr>
              </thead>
            </div>
          `,
          url: `/gvendas/clientes/${parseInt(cliente?.id || cliente)}/reprogramar-pagamentos/`,
          dados: formData,
          tipo:"baixar-cliente",
          id: parseInt(cliente?.id || cliente),
          data: new Date().toLocaleString("sv-SE"),
        });
        //Colocar url da fila;
        Toast.fire({
          icon: 'success',
          title: 'Reagendamento adicionado na lista de espera de conexão!'
        });
        navigate(`/painel/sync`, { replace: true });
      }
      else {
        Swal.fire({
            title: `Erro ${err.status || err.code}`,
            text: err.response?.data?.detail || 'Falha ao atualizar pagamentos',
            icon: "error"
        });
      }
    }finally{

    }
  }
  
  const gerarLinha = () => {
    if (lista.length <= 0) {
        return adicionarLinha();
    }

    const totalPago = lista.reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;

    const total = parseFloat(cliente?.total_aberto || 0);
    const totalAberto = total - totalPago;

    const temLinhaAberto = lista.length;
    
    if (totalAberto > 0 && !temLinhaAberto) {
        adicionarLinha();
    }
  };


  // Função para dividir o total da sacola pelas linhas não paga
  const dividirTotal = async() => {
    const linhasNaoPagas = lista || [];
    const totalGeral = parseFloat(cliente.total_aberto || 0);
  
    let novaTabela = [];
    //Ajustar para ultima linha se tiver valor nao pago
    if (naUltima && linhasNaoPagas.length > 0) {
      const valorTotal = (lista || []).reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;
  
      // Se naUltima for true, apenas altera a última linha não paga
      const ultimaLinhaNaoPaga = linhasNaoPagas[linhasNaoPagas.length - 1];
  
      // Atualiza o valor da última linha não paga com o valor total restante
      //ultimaLinhaNaoPaga.valor = (valorTotal + parseFloat(ultimaLinhaNaoPaga.valor||0)).toFixed(2) //(totalGeral - valorTotal).toFixed(2);
      //ultimaLinhaNaoPaga.valor = (totalRestante - valorTotal + parseFloat(ultimaLinhaNaoPaga.valor||0)).toFixed(2)
      ultimaLinhaNaoPaga.valor = (parseFloat(cliente?.total_aberto) - valorTotal + parseFloat(ultimaLinhaNaoPaga.valor||0)).toFixed(2) //(totalGeral - valorTotal).toFixed(2);
      //ultimaLinhaNaoPaga.valor = (parseFloat(ultimaLinhaNaoPaga.valor||0)).toFixed(2) //(totalGeral - valorTotal).toFixed(2);
      //alert(`Valor Total: ${valorTotal} Valor Geral: ${totalGeral} Diferença: ${ultimaLinhaNaoPaga.valor}`);
  
      // Atualiza a tabela com o novo valor da última linha
      novaTabela = lista.map((linha) =>
        linha === ultimaLinhaNaoPaga ? ultimaLinhaNaoPaga : linha
      );
  
      // Exclui as linhas com valor <= 0
      novaTabela = novaTabela.filter((linha) => (parseFloat(linha.valor) > 0 || linha.valor===""));
      if (JSON.stringify(lista) !== JSON.stringify(novaTabela)) {
        setLista(novaTabela);
      }
      
    } else if (linhasNaoPagas.length > 0) {
      // Caso contrário, divide o valor entre todas as linhas não pagas
      let valorPorLinha =
        linhasNaoPagas.length > 0 ? totalGeral / linhasNaoPagas.length : 0;
  
      // Arredonda o valor por linha para 2 casas decimais
      valorPorLinha = Math.round(valorPorLinha * 100) / 100;
  
      // Calcula a diferença do total geral, considerando o arredondamento
      const somaValorPorLinha = valorPorLinha * linhasNaoPagas.length;
      const ajuste = totalGeral - somaValorPorLinha;
  
      // Atualiza a última linha para corrigir a diferença
      novaTabela = lista.map((linha, index) => {
        const valorAtualizado =
            index === linhasNaoPagas.length - 1
              ? (valorPorLinha).toFixed(2)
              : valorPorLinha.toFixed(2);
        return { ...linha, valor: valorAtualizado };
      });
  
      // Exclui as linhas com valor <= 0
      novaTabela = novaTabela.filter((linha) => parseFloat(linha.valor) > 0 || linha.valor==="");
      if (JSON.stringify(lista) !== JSON.stringify(novaTabela)) {
        setLista(novaTabela);
      }
    }
  };
  
  // Função para ajustar a última linha não paga
  const ajustarUltimaLinhaNaoPaga = () => {
    //if (!lista?.length) alert("saiu")
    
    const linhasNaoPagas = lista||[];
    const totalNaoPagos = parseFloat(cliente?.total_aberto || 0);

    const valorPorLinha = totalNaoPagos / lista.length;

    const novaTabela = lista.map((linha, index) => {
      if (index === lista.length - 1) {
        return { ...linha, valor: valorPorLinha.toFixed(2) };
      }
      return linha;
    });

    setLista(novaTabela);
  };

  // Função para adicionar uma nova linha com a data ajustada
  const adicionarLinha = () => {
    try {
      //setNaUltima(false);
      let novaData;
      if (lista.length > 0) {
        // Se houver pelo menos uma linha, adiciona 7 dias à última data
        const ultimaLinha = lista[lista.length - 1];
        novaData = new Date(ultimaLinha.data);
  
        if (isNaN(novaData)) throw new Error("Data inválida na última linha.");
        
        const dias_parcelamento = auth?.empresa?.configuracoes?.dias_parcelamento || 7;
        novaData.setDate(novaData.getDate() + dias_parcelamento); // Adiciona 7 dias à última data
      } else {
        // Se não houver nenhuma linha, usa a data inicial
        //novaData = new Date(venda?.data_da_venda || Date.now());
        novaData = new Date(Date.now());
  
        if (isNaN(novaData)) throw new Error("Data inicial inválida.");
      }
      
      const novaLinha = {
        valor: parseFloat(lista?.length<=0?(cliente?.total_aberto||0):0).toFixed(2),
        data: novaData.toLocaleDateString("sv-SE"), // Formata para 'YYYY-MM-DD'
      };
  
      const novaTabela = [...lista, novaLinha];
  
      novaTabela.sort((a, b) => new Date(a.data) - new Date(b.data)); // Ordena as linhas pela data
      
      setLista(novaTabela);
    } catch (error) {
      console.error("Erro ao adicionar linha:", error.message);
    }
  };

  // Função para remover uma linha da tabela
  const removerLinha = (index) => {
    const novaTabela = lista.filter((linha, i) => i != index);
    setLista(novaTabela);
  };
  
  
  // Função para lidar com alterações nos inputs
  const handleInputChange = async(index, field, value) => {
    const novaTabela = [...lista];

    // Se o campo for "valor" e a linha não está paga
    if (field === "valor") {
      novaTabela[index][field] = value.value;
      ajustarUltimaLinhaNaoPaga();
    }
    
    if (field === "data") {
      novaTabela[index][field] = value.value;
    }

    // Verifica se a última linha tem valor <= 0 e não está paga
    if (novaTabela[novaTabela.length - 1].valor <= 0 && value && novaTabela[novaTabela.length - 1].valor !== "") {
      novaTabela.pop(); // Remove a última linha se o valor for <= 0
    }
    
    // Reordena a tabela pela data, mesmo que a linha tenha sido paga
    novaTabela.sort((a, b) => new Date(a.data) - new Date(b.data));

    // Atualiza a tabela
    setLista(novaTabela);
  };
  const handleInputChangeFixed = async(index, field, value) => {
    const novaTabela = [...lista];

    // Se o campo for "valor" e a linha não está paga
    if (field === "valor" && !novaTabela[index].pago) {
      novaTabela[index][field] = parseFloat(value.value||0).toFixed(2);
    }

        // Verifica se a última linha tem valor <= 0 e não está paga
    if (novaTabela[novaTabela.length - 1].valor <= 0 && value && novaTabela[novaTabela.length - 1].valor !== "") {
      novaTabela.pop(); // Remove a última linha se o valor for <= 0
    }

    // Atualiza a tabela
    setLista(novaTabela);
  }
  
  const integridade =()=>{
    gerarLinha();
    dividirTotal();
  }
  
  useEffect(() => {
    integridade();
  }, [lista]);

  return (
    <div className="pb-5">
      <div className="bs-floating shadow navbar-light">
        <div className="container py-2">
          <Button variant="secondary" onClick={salvarPagamentos} disabled={loading} className="w-100 btn-lg">
              Salvar alterações
          </Button>
        </div>
      </div>
      <Row className="align-items-center">
        <Col>
          <div className="small text-muted">{"Total em Aberto"}</div>
          <div className="fs-4">
            {parseFloat(cliente?.total_aberto||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
          </div>
        </Col>
        <Col>
        </Col>
      </Row>
      <h6 className="border-dashed-bottom">Forma de pagamento</h6>
      <div className="table-responsive">
        <table className="table w-100">
          <thead>
            <tr>
              <th>Valor</th>
              <th>Data</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.map((linha, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="number"
                    className="form-control preco moeda"
                    value={linha.valor}
                    //readOnly={linha.pago} // Congela o valor quando pago
                    onChange={(e) => handleInputChange(index, "valor", e.target)}
                    onBlur={(e) => { handleInputChangeFixed(index, "valor", e.target);}}
                    onFocus={(e) => { setNaUltima(true); }} // Função ao focar
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={linha.data}
                    //readOnly={linha.pago}
                    onChange={(e) => {handleInputChange(index, "data", e.target);}}
                  />
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => {removerLinha(index); setNaUltima(false);}}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-center">
          <button
            className="btn btn-dark mb-5 mt-3 btn-sm w-100"
            onClick={()=>{adicionarLinha();setNaUltima(false);}}
          >
            Criar nova parcela
          </button>
      </div>
    </div>
  );
};
const Agenda = ({ cliente}) => {
  const [agendas, setAgendas] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const {
    crud,
  } = useProvider();
  const { del, loading, get, post } = crud||{};
  
  const buscarAgendas = async (novaBusca = false) => {
    let url = `/gvendas/agendas/?clientes__in=${cliente?.id}&ordering=-data`;
    
    if (novaBusca) {
      setAgendas([]);
      setNextUrl(null);
    } else if (nextUrl) {
      url = nextUrl;
    } else {
      url = null;
    }

    if (!url) return;
    try {
      const response = await get(url, 'pagina');
      if (response && response.length) {
        const novosAgendas = response[0].results;
        setAgendas((agendasAnteriores) => novaBusca ? novosAgendas : [...agendasAnteriores, ...novosAgendas]);
        setNextUrl(response[0].next);
      }
    } catch (err) {

    }
  };

  // Inicialização
  useEffect(() => {
    if (cliente) {
      buscarAgendas(true);
    }
  }, [cliente]);

  // Detecta o fim da página para carregar mais agendas
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading) buscarAgendas();
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [nextUrl, loading]);


  const agendasAgrupadas = agendas?.reduce((acc, agenda) => {
    const data = dayjs(agenda.data).format("DD/MM/YYYY dddd");
    if (!acc[data]) {
      acc[data] = [];
    }
    acc[data].push(agenda);
    return acc;
  }, {});

  const getCor =(item)=>{
    switch (item.status){
      case 'Atrasado':
        return "red";
      case 'Cancelado':
        return "grey";
      case 'Realizado':
        return "green";
    }
  }

  return (
    <>
      <div className="list-group mt-3">
        {Object.entries(agendasAgrupadas).length > 0 ? (
          Object.entries(agendasAgrupadas).map(([data, agendasDoDia]) => (
            <div key={data}>
              <div className="text-muted mt-2">{data}</div>
              {agendasDoDia.map((x) => (
                <RenderizarProduto
                  key={x.id} // Adicionando key para cada componente da lista
                  to={`/agenda?p=detalhes&i=${x.id}`}
                  col="d-none"
                  lm="mb-1"
                  bcolor={getCor(x)}
                  text1={`${x.status} - ${x.titulo || ''}`}
                  titulo={`${dayjs(x.data).format("DD/MM")} às ${dayjs(x.data).format("HH:mm")}`}
                  text2={(<>
                    {x.clientes?.length>0 && (<>{`${x.clientes.length} contato${x.clientes.length>1?'s':''}`}</>)}
                    {x.leads?.length>0 && (<>{`${x.leads.length} lead${x.leads.length>1?'s':''}`}</>)}
                    {x.checkins?.length>0 && (<>{`, ${x.checkins.length} presença${x.checkins.length>1?'s':''}`}</>)}
                    {x.observacoes && (<div>{x.observacoes}</div>)}
                  </>)}
                />
              ))}
            </div>
          ))
        ) : (
          !loading && <p className="text-center text-muted">Nenhuma agenda encontrada.</p>
        )}
        {loading && <p className="text-center"><Spinner animation="border" /></p>}
        {(!loading && nextUrl) && (
          <Button variant="secondary" onClick={() => buscarAgendas(false)} className="mt-2">
            Buscar mais...
          </Button>
        )}
      </div>
    </>
  );
};

const MensagensWhatsApp =({cliente})=>{
  const [mensagens, setMensagens] = useState([]);
  const {
    crud
  } = useProvider();
  const { get, del, loading } = crud || {}
  
  const excluirMensagem =async(id)=>{
    Swal.fire({
      title: "Excluir Mensagem",
      text: "Tem certeza que quer excluir essa mensagem cancelando o agendamento de envio?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, excluir!"
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
          await del(`/core/mensagens-whatsapp/${id}/`);
          Toast.fire({
              icon: "success",
              title: `Mensagem excluída com sucesso`
          });
          setMensagens(prev => prev.filter(x => x.id !== id));
        }catch(err){
          Swal.fire({
            title: `Erro ${err.status}`,
            text: 'Mensagem não pode ser excluído',
            icon: "error"
          });
        }finally{
          
        }
      }
    });
  }
  
  useEffect(()=>{
    const buscarMensagens = async()=>{
      try{
          const response = await get(`/core/mensagens-whatsapp/?contato=${parseInt(cliente?.contato?.id||cliente?.contato)}&ordering=-data_programada,-data_criacao`, 'mensagens-whatsapp');
          if(response && response.length){
            setMensagens(response[0].results);
          }
      }catch(err){
        
      }
    }
    buscarMensagens();
  }, [cliente])
  return (<>
    <div className="list-group mt-3">
        {mensagens.length > 0 ? (
            mensagens.map((x) => (
              <Row>
                  <Col></Col>
                  <Col xs="auto">
                    {(!x.data_programada && !x.data_envio) && (<>
                      Criada {dayjs(x.data_criacao).format("DD/MM/YYYY [às] HH:mm")}
                    </>)}
                    {(x.data_programada && !x.data_envio) && (<>
                      Agendada {dayjs(x.data_programada).format("DD/MM/YYYY [às] HH:mm")}
                    </>)}
                    {x.data_envio && (<>
                      Enviada {dayjs(x.data_envio).format("DD/MM/YYYY [às] HH:mm")}
                      <div className="small">{x.telefone}</div>
                    </>)}
                    {!x.data_envio && (<>
                      <Button variant="danger" className="ms-2" size="sm" onClick={()=>excluirMensagem(x.id)}><i className="bx bx-trash"></i></Button>
                    </>)}
                  </Col>
                  <Col xs={12}>
                    <div className="list-group-item list-group-item-action mb-2">
                      <Markdown texto={x.mensagem}></Markdown>
                    </div>
                  </Col>
              </Row>
            ))
        ) : (
            !loading && <p className="text-center text-muted">Nenhuma mensagem encontrada.</p>
        )}
    </div>
  </>)
}


export default ClienteDetails;